import * as React from 'react'
import Skeleton from "react-loading-skeleton";

const ClosedCasesSkeleton = () => {
  return (
    <tr className="closed-cases-bulk__case">  
      <td><Skeleton count={1} width={"30%"} height={10} /></td>
      <td className="closed-cases-bulk__child">
        <div className="child-photo__container">
          <Skeleton circle={true} width={50} height={50} /> 
          <Skeleton count={1} width={150} height={10}/>
        </div>
      </td>
      <td><Skeleton count={1} width={"40%"} height={10} /></td>
      <td><Skeleton count={1} width={"70%"} height={10} /></td>
    </tr>
  )
}

export default ClosedCasesSkeleton
